export default function Cart() {
  return <div>Giỏ hàng của bạn</div>;
}

export {};
